import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { chatApi, type DecisionEmails as Choice } from "./api";
import { useLang } from "./lang";

const OPTIONS: { value: Choice; en: string; ar: string }[] = [
  { value: "digest", en: "Once a day", ar: "مرة في اليوم" },
  { value: "instant", en: "As each one comes", ar: "عند وصول كل قرار" },
  { value: "off", en: "Never", ar: "أبدًا" },
];

/**
 * How decisions reach me by email (decision-email plan, part 1): a daily
 * digest unless I pick otherwise. Lives in the me-menu and the sidebar.
 */
export function DecisionEmails({ workspaceId, id }: { workspaceId: string; id: string }) {
  const { t } = useLang();
  const qc = useQueryClient();
  const key = ["decision-emails", workspaceId];
  const q = useQuery({ queryKey: key, queryFn: () => chatApi.decisionEmails(workspaceId), enabled: !!workspaceId });
  const save = useMutation({
    mutationFn: (v: Choice) => chatApi.setDecisionEmails(workspaceId, v),
    onSuccess: (r) => qc.setQueryData(key, r),
  });
  const value = save.isPending && save.variables ? save.variables : (q.data?.decision_emails ?? "digest");
  return (
    <label className="pwa-emails" htmlFor={id}>
      <span>{t({ en: "Email me about decisions", ar: "راسلني بشأن القرارات" })}</span>
      <select id={id} value={value} disabled={q.isLoading} onChange={(e) => save.mutate(e.target.value as Choice)}>
        {OPTIONS.map((o) => (
          <option key={o.value} value={o.value}>
            {t(o)}
          </option>
        ))}
      </select>
      {save.isError ? <span className="pwa-emails-error">{t({ en: "Couldn't save that. Try again.", ar: "تعذّر الحفظ. حاول مرة أخرى." })}</span> : null}
    </label>
  );
}
